"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneVerificationInDepositBonus = exports.PhoneVerificationInDepositInput = void 0;
var PhoneVerificationInDepositInput_1 = require("./PhoneVerificationInDepositInput");
Object.defineProperty(exports, "PhoneVerificationInDepositInput", { enumerable: true, get: function () { return PhoneVerificationInDepositInput_1.PhoneVerificationInDepositInput; } });
var PhoneVerificationInDepositBonus_1 = require("./PhoneVerificationInDepositBonus");
Object.defineProperty(exports, "PhoneVerificationInDepositBonus", { enumerable: true, get: function () { return __importDefault(PhoneVerificationInDepositBonus_1).default; } });
